import React, { memo } from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TextDeleteTagModal = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="TextDeleteTagModal" className="dialog-text">
      <p>{t('clientTags.deleteTagModal.text1')}</p>
      <p>
        {t('clientTags.deleteTagModal.text2')}
        <br />
        {t('clientTags.deleteTagModal.text3')}
      </p>
      <p>{t('clientTags.deleteTagModal.text4')}</p>
    </div>
  );
};

export default memo(TextDeleteTagModal);
